<script>
export default {
  mounted () {
    const redirectURL = window.localStorage.getItem('callback_uri')
    window.location.replace(`${redirectURL}`)
  }
}
</script>